<section id="sponsor">
	<br/>
  <i class="fas fa-donate speaker-icon text-center"></i>
  <h2 class="section-heading">SPONSORSHIP</h2>
  <ul class="list-group text-center">
  	<li class="list-group-item" style="
  	    background-color: #FFFEA9;
  	">Platinum Sponsor (Organizing Partner):₹5,00,000/-</li> <li class="list-group-item" style="
  	    background-color: #E6DF9A;
  	">Gold Sponsor:₹2,00,000/-</li> <li class="list-group-item" style="
  	    background-color: #DAD992;
  	">Silver Sponsor:₹1,00,000/-</li>
  </ul>
  <br/>
  <h2 class="section-heading">Advertisements</h2>
  <ul class="list-group text-center">
  	<li class="list-group-item" style="
  	    background-color: #FFE3E3;
  	">Souvenir (Back page):INR    25,000/-</li>
  	<li class="list-group-item" style="
  	    background-color: #E4D8DC;
  	">Souvenir (Font Inside and Back inside):INR    15,000/-</li>
  	<li class="list-group-item" style="
  	    background-color: #C9CCD5;
  	">Souvenir (One Page):INR    10,000/-</li>
  </ul>
  <!-- <p>SCIE journal and SCOPUS journals are planned separately - .<br/>... Details Coming Soon...</p> -->
</section>
<style>
	section {
		padding-top: 86px;
		text-align: center;
	}
	i {
		display: block;
		margin: 0 auto;
		font-size: 2rem;
		padding-bottom: 1em;
	}
	h2 {
		text-align: center;
	}
	p {
		text-align: center;
		width: 80%;
		margin: 0 auto;
		font-size: 1.1em;
	}

	@media all and (min-width: 768px) {
	  p {
	    width: 60%;
	  }
	}
</style>
